var _defs, _rect, _path, _circle, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 56,
    viewBox: "0 0 220 56",
    role: "img",
    "aria-label": "GadgetBiz logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c3aed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22c55e"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    rx: 14,
    fill: "#0b1220"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32c0-8 6-14 14-14 3 0 6 1 8 3l6-6 4 4-6 6c2 2 3 5 3 8 0 8-6 14-14 14S16 40 16 32z",
    fill: "url(#g)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 32,
    r: 4.5,
    fill: "#e5e7eb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74 37V19h14c5 0 8 2.4 8 6.6 0 2.8-1.3 4.9-3.7 5.9 2.8.9 4.4 3.2 4.4 6.2 0 4.8-3.6 7.3-9.2 7.3H74zm7-11h6.2c1.9 0 3-1 3-2.4 0-1.6-1.1-2.4-3.1-2.4H81V26zm0 6.2h6.7c2.2 0 3.4-1 3.4-2.7 0-1.6-1.3-2.5-3.4-2.5H81v5.2z",
    fill: "#e5e7eb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.3 37.4c-6 0-10.3-4-10.3-9.7s4.3-9.7 10.3-9.7c5.1 0 8.7 2.5 9.6 6.6h-6.2c-.7-1.5-1.8-2.3-3.4-2.3-2.4 0-4 2.1-4 5.4s1.6 5.4 4 5.4c1.9 0 3.2-1 3.6-2.7h-3.8v-4.2h10v2.6c0 5.2-3.9 8.6-9.8 8.6z",
    fill: "#e5e7eb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136 37V22.9h-4.9V19H148v3.9h-5V37h-7z",
    fill: "#e5e7eb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.3 37.4c-6 0-10.3-4-10.3-9.7s4.3-9.7 10.3-9.7c6 0 10.3 4 10.3 9.7s-4.3 9.7-10.3 9.7zm0-4.3c2.5 0 4.1-2.1 4.1-5.4s-1.6-5.4-4.1-5.4-4.1 2.1-4.1 5.4 1.6 5.4 4.1 5.4z",
    fill: "#e5e7eb"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M177 37V19h7v6.5h6.6V19h7v18h-7v-7.3H184V37h-7z",
    fill: "#e5e7eb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.365c7251bb49092e01151e1e3b055128.svg";
export { ForwardRef as ReactComponent };